import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  EMAIL_ERROR_MESSAGE,
  PASSWORD_ERROR_MESSAGE,
  PHONE_NUMBER_ERROR_MESSAGE,
} from "../constants/auth";
import { appActions } from "../ducks/app";
import { authActions, authSelectors } from "../ducks/auth";

export const useAuth = () => {
  const dispatch = useDispatch();

  const isLoggedIn = useSelector(authSelectors.isLoggedIn);
  const loggedInUser = useSelector(authSelectors.loggedInUser);

  const getLoggedInUser = useCallback(() => {
    dispatch(authActions.getUser.started({}));
  }, []);

  const handleEmailError = useCallback(() => {
    dispatch(
      appActions.showModal.started({
        title: EMAIL_ERROR_MESSAGE,
        nextButtonLabel: "閉じる",
        handleNext: () => dispatch(appActions.closeModal()),
      }),
    );
  }, []);

  const handlePasswordError = useCallback(() => {
    dispatch(
      appActions.showModal.started({
        title: "エラーが発生しました。",
        subTitle: PASSWORD_ERROR_MESSAGE,
        nextButtonLabel: "閉じる",
        handleNext: () => dispatch(appActions.closeModal()),
      }),
    );
  }, []);

  const handleAuthValidationError = useCallback(
    (
      isValidPhoneNumber: boolean,
      isValidEmail: boolean,
      isValidPassword: boolean,
    ) => {
      const errors = [];

      if (!isValidPhoneNumber) errors.push(PHONE_NUMBER_ERROR_MESSAGE);
      if (!isValidEmail) errors.push(EMAIL_ERROR_MESSAGE);
      if (!isValidPassword) errors.push(PASSWORD_ERROR_MESSAGE);

      dispatch(
        appActions.showModal.started({
          title: "エラーが発生しました。",
          subTitle: "・" + errors.join(`\n・`),
          nextButtonLabel: "閉じる",
          handleNext: () => dispatch(appActions.closeModal()),
        }),
      );
    },
    [],
  );

  return {
    isLoggedIn,
    loggedInUser,
    getLoggedInUser,
    handleEmailError,
    handlePasswordError,
    handleAuthValidationError,
  };
};
